import { render } from "./PortfolioLandingView.vue?vue&type=template&id=4b58f584"
import script from "./PortfolioLandingView.vue?vue&type=script&lang=js"
export * from "./PortfolioLandingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__